export default {
   "common.popup.usePromoCode": "Usando el código de promoción: {code}",
   "common.rooms.promotion.offer": "{quantity, plural, one {Oferta} other {Ofertas}}",
   "common.rooms.promotion.code": "Código de promoción",
   "common.rooms.promotion.minors.free": "{quantity, plural, =0 {Todos los menores gratis} =1 {# menor gratis} other {# menores gratis}}",
   "common.promotion.night.free": "{quantity, plural, =1 {1ra noche gratis cada {days} días} =2 {2da noche gratis cada {days} días} other {#a noche gratis cada {days} días}}",
   "common.rooms.promotion.off": "de descuento",
   "common.promotion.buttonText": "Reserva ahora",
}